// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #ece4ed;
  --text: #0b1220;
  --muted: #5b6b83;
  --border: #d8e0eb;
  --card: #ffffff;
  --blue: #7A2A85;
  --blue2: #400C4D;
  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);
}

.wu-page {
  --wu-type-heading: clamp(30px, 2.4vw, 38px);
  --wu-type-subheading: clamp(24px, 2vw, 32px);
  --wu-type-card-heading: 1.25rem;
  --wu-type-body: 1.0625rem;
  --wu-type-card-body: 1.0625rem;
  --wu-type-cta: 0.95rem;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

.wu-container {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 18px;
}

.wu-hero {
  background: #400C4D;
  border-radius: 16px;
  margin: 0.75rem 0;
  padding: 2.5rem 2rem;
}

.wu-hero__content {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: space-between;
}

.wu-hero__text {
  flex: 1.3;
}

.wu-hero__quote {
  margin: 0;
  font-family: 'Lexend', system-ui, -apple-system, sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #fff;
  font-size: clamp(28px, 3.5vw, 46px);
  line-height: 1.25;
}

.wu-hero__subtext {
  margin: 1rem 0 0 0;
  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;
  font-style: normal;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(18px, 2vw, 24px);
  line-height: 1.4;
}

.wu-hero__visual {
  flex: 0.9;
  min-height: 300px;
  border-radius: 24px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  align-self: stretch;
  width: clamp(220px, 26vw, 360px);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-12px);
}

@media (max-width: 960px) {
  .wu-hero__content {
    flex-direction: column;
    text-align: left;
  }

  .wu-hero__visual {
    width: 100%;
    min-height: 200px;
  }
}

.wu-section {
  padding: 44px 0;
  background: var(--bg);
}

.wu-section--white {
  background: var(--bg);
  padding-top: 56px;
}

.wu-section--white .wu-container {
  max-width: 1320px;
}

.wu-philosophy {
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 44px;
  align-items: start;
}

.wu-philosophy__image {
  position: relative;
  overflow: hidden;
}

.wu-philosophy__image img {
  width: 70%;
  height: 200x;
  object-fit: cover;
  display: block;
  border-radius: 0;
  margin-left: 2rem;
}

.wu-imageTag {
  display: none;
}

.wu-eyebrow {
  display: inline-flex;
  align-items: center;
  gap:12px;
  color: #400C4D;
  font-weight: 900;
  font-size: 0.9rem;
  letter-spacing: 0.14em;
}

.wu-eyebrow__line {
  width: 26px;
  height: 2px;
  background: #400C4D;
  border-radius: 999px;
  opacity: 0.9;
}

.wu-title {
  margin: 10px 0 10px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: var(--wu-type-subheading);
  line-height: 1.12;
  color:#400C4D
}

.wu-text {
  margin: 0 0 12px;
  color: #400C4D;
  font-size: var(--wu-type-body);
  line-height: 1.65;
}

.wu-quoteBox {
  position: relative;
  background: #d6c3d9;
  border: 1px solid #400C4D;
  border-radius: 12px;
  padding: 14px 16px 16px 10px;
  margin: 10px 0 12px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);
  font-size: 20px ;
}

.wu-quoteBox__bar {
  position: absolute;
  left: 14px;
  top: 14px;
  bottom: 14px;
  width: 6px;
  background: #400C4D;
  border-radius: 999px;
}

.wu-quoteBox p {
  margin: 0;
  padding-left: 10px;
  color: #2b3a55;
  font-size: 1.125rem;
  font-style: italic;
  line-height: 1.55;
}

.wu-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #400C4D;
  font-weight: 900;
  font-size: 18px;
}

.wu-link__arrow {
  font-weight: 900;
}

.wu-centerTitle {
  margin: 0;
  text-align: center;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  font-size: 25px;
  letter-spacing: -0.02em;
  line-height: 1.05;
  color: #400C4D;
}

.wu-centerSub {
  margin: 8px auto 0;
  text-align: center;
  color: #400C4D;
  font-size: 16px;
  max-width: 520px;
  line-height: 1.55;
}

.wu-what-layout {
  margin-top: 12px;
  display: grid;
  gap: 28px;
  grid-template-columns: minmax(210px, 0.65fr) minmax(0, 2.35fr);
  align-items: start;
  margin-left: -420px;
}

.wu-what-image {
  border-radius: 0;
  overflow: visible;
  position: relative;
  z-index: 3;
  margin-left: 0;
  transform: translate(70px, -140px);

}

.wu-what-image img {
  width: 160%;
  max-width: none;
  height: auto;
  min-height: 100px;
  display: block;
  margin-left: 0;
  margin-bottom: 0;
  object-fit: contain;
}

.wu-what-content {
  display: flex;
  flex-direction: column;
  margin-left: 0;
}

.wu-what-title {
  margin: 0 0 10px;
  text-align: center;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  font-size: var(--wu-type-heading);
  color: #400C4D;
  line-height: 1.1;
  margin-left: 0;
}

.wu-what-sub {
  margin: 0 0 24px;
  text-align: center;
  color: #400C4D;
  font-size: var(--wu-type-body);
  line-height: 1.6;
  margin-left: 0;
  max-width: 760px;
  align-self: center;
}

.wu-grid {
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(4, minmax(250px, 1fr));
  gap: 16px;
}

.wu-card {
  background: #ece4ed;
  border: 1px solid rgba(64, 12, 77, 0.14);
  border-radius: 24px;
  padding: 26px 22px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05);
  min-height: 235px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: flex-start;
}

.wu-card__icon {
  width: 96px;
  height: 96px;
  border-radius: 999px;
  background: #d6c3d9;
  color: #400C4D;
  display: grid;
  place-items: center;
  margin-bottom: 14px;
}

.wu-card__icon .material-symbols-outlined {
  font-size: 38px;
}

.wu-card__title {
  margin: 0 0 10px;
  font-weight: 900;
  font-size: clamp(1.4rem, 1.5vw, 1.75rem);
  color:#400C4D
}

.wu-card__text {
  margin: 0;
  color: #400C4D;
  font-size: clamp(1.05rem, 1.15vw, 1.3rem);
  line-height: 1.5;
}

.wu-card:nth-child(3n + 2) {
  background: #400C4D;
  border-color: #400C4D;
  box-shadow: 0 20px 34px rgba(64, 12, 77, 0.3);
}

.wu-card:nth-child(3n + 2) .wu-card__icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.wu-card:nth-child(3n + 2) .wu-card__title,
.wu-card:nth-child(3n + 2) .wu-card__text {
  color: #ffffff;
}

.wu-elite {
  margin-top: 34px;
  background: #ece4ed;
  border-radius: 20px;
  padding: 26px 18px 22px;
}

.wu-elite__title {
  margin: 0 0 18px;
  text-align: center;
  color: #400C4D;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 800;
  font-size: clamp(26px, 2.8vw, 42px);
}

.wu-elite__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.wu-eliteCard {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.03));
  border: 2px solid #400C4D;
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  min-height: 230px;
}

.wu-eliteCard__icon {
  width: 62px;
  height: 62px;
  margin: 0 auto 14px;
  border-radius: 50%;
  border: 2px solid #400C4D;
  display: grid;
  place-items: center;
  color: #400C4D;
}

.wu-eliteCard__icon .material-symbols-outlined {
  font-size: 31px;
}

.wu-eliteCard__title {
  margin: 0 0 10px;
  color: #400C4D;
  font-size: var(--wu-type-card-heading);
  font-weight: 800;
}

.wu-eliteCard__text {
  margin: 0;
  color: #400C4D;
  font-size: 15px;
  line-height: 1.55;
}

.wu-eliteCard__list {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

.wu-eliteCard__item {
  position: relative;
  color: #400C4D;
  font-size: var(--wu-type-card-body);
  line-height: 1.6;
  padding-left: 22px;
  margin-bottom: 7px;
}

.wu-eliteCard__item:last-child {
  margin-bottom: 0;
  font-weight: 800;
}

.wu-eliteCard__item::before {
  content: "▶";
  position: absolute;
  left: 0;
  top: 0;
  color: #400C4D;
  font-size: 0.9rem;
  line-height: 1.8;
}

.wu-bottom {
  background: #d6c3d9;
  padding: 60px 0;
}

.wu-bottom__inner {
  text-align: center;
}

.wu-bottom__title {
  margin: 0;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  font-size: clamp(26px, 3vw, 38px);
  letter-spacing: -0.02em;
  line-height: 1.05;
  color:#400C4D
}

.wu-bottom__text {
  margin: 12px auto 0;
  max-width: 560px;
  color: #400C4D;
  font-size: var(--wu-type-body);
  line-height: 1.6;
}

.wu-actions {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.wu-btn {
  border: none;
  cursor: pointer;
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 900;
  font-size: var(--wu-type-cta);
  transition: transform 0.15s ease, filter 0.15s ease;
}

.wu-btn:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  filter: brightness(1.02);
}

.wu-btn--primary {
  background: #400C4D;
  color: #fff;
  box-shadow: 0 10px 20px rgba(64, 12, 77, 0.25);
}

.wu-btn--secondary {
  background: #fff;
  color: #400C4D;
  border: 1px solid #cfe0ff;
}

@media (max-width: 980px) {
  .wu-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wu-elite__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wu-philosophy {
    grid-template-columns: 1fr;
  }
  .wu-philosophy__image img {
    height: 320px;
  }
  .wu-what-layout {
    grid-template-columns: 1fr;
  }
  .wu-what-image img {
    min-height: 360px;
  }
}

@media (max-width: 640px) {
  .wu-container {
    padding: 0 16px;
  }

  .wu-section {
    padding: 34px 0;
  }

  .wu-philosophy {
    gap: 18px;
  }

  .wu-philosophy__image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2px;
  }

  .wu-philosophy__image img {
    width: 48%;
    height: auto;
    margin-left: 0;
  }

  .wu-philosophy__content {
    margin-top: 6px;
  }

  .wu-title {
    font-size: 24px;
    line-height: 1.18;
  }

  .wu-quoteBox {
    padding: 14px 14px 16px 18px;
  }

  .wu-quoteBox__bar {
    left: 10px;
  }

  .wu-quoteBox p {
    padding-left: 14px;
  }
}

@media (max-width: 520px) {
  .wu-grid {
    grid-template-columns: 1fr;
  }
  .wu-elite__grid {
    grid-template-columns: 1fr;
  }
  .wu-hero {
    margin: 0 0 0.75rem;
    padding: 1.5rem 1rem 1.1rem;
    border-radius: 0 0 16px 16px;
  }

  .wu-hero__content {
    gap: 0.75rem;
  }

  .wu-hero__visual {
    min-height: 150px;
    background-position: center 35%;
    transform: none;
  }
}

@media (max-width: 640px) {
  .wu-what-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 0;
  }

  .wu-what-image {
    margin-left: 0;
    transform: translate(0, 0);
  }

  .wu-what-image img {
    min-height: 320px;
    width: 100%;
    margin-bottom: 0;
  }

  .wu-what-content {
    margin-left: 0;
  }

  .wu-what-title,
  .wu-what-sub {
    margin-left: 0;
  }

  .wu-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .wu-card {
    width: 100%;
    min-height: 180px;
  }

  .wu-grid::-webkit-scrollbar {
    height: 6px;
  }

.wu-grid::-webkit-scrollbar-thumb {
  background: rgba(64, 12, 77, 0.4);
  border-radius: 999px;
}

}

@media (max-width: 960px) {
  .wu-hero__content {
    flex-direction: column;
    text-align: left;
  }

  .wu-hero__visual {
    width: 100%;
    min-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/WhyUnique/whyUnique.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,8DAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kCAAkC;;AAEpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC;AACF;;AAEA;EACE,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iDAAiD;EACjD,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yFAAyF;EACzF,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;AAEF;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700\");\n\n:root {\n  --bg: #ece4ed;\n  --text: #0b1220;\n  --muted: #5b6b83;\n  --border: #d8e0eb;\n  --card: #ffffff;\n  --blue: #7A2A85;\n  --blue2: #400C4D;\n  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);\n}\n\n.wu-page {\n  --wu-type-heading: clamp(30px, 2.4vw, 38px);\n  --wu-type-subheading: clamp(24px, 2vw, 32px);\n  --wu-type-card-heading: 1.25rem;\n  --wu-type-body: 1.0625rem;\n  --wu-type-card-body: 1.0625rem;\n  --wu-type-cta: 0.95rem;\n  background: var(--bg);\n  color: var(--text);\n  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n}\n\n.wu-container {\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 0 18px;\n}\n\n.wu-hero {\n  background: #400C4D;\n  border-radius: 16px;\n  margin: 0.75rem 0;\n  padding: 2.5rem 2rem;\n}\n\n.wu-hero__content {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.wu-hero__text {\n  flex: 1.3;\n}\n\n.wu-hero__quote {\n  margin: 0;\n  font-family: 'Lexend', system-ui, -apple-system, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  color: #fff;\n  font-size: clamp(28px, 3.5vw, 46px);\n  line-height: 1.25;\n}\n\n.wu-hero__subtext {\n  margin: 1rem 0 0 0;\n  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: clamp(18px, 2vw, 24px);\n  line-height: 1.4;\n}\n\n.wu-hero__visual {\n  flex: 0.9;\n  min-height: 300px;\n  border-radius: 24px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  align-self: stretch;\n  width: clamp(220px, 26vw, 360px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-12px);\n}\n\n@media (max-width: 960px) {\n  .wu-hero__content {\n    flex-direction: column;\n    text-align: left;\n  }\n\n  .wu-hero__visual {\n    width: 100%;\n    min-height: 200px;\n  }\n}\n\n.wu-section {\n  padding: 44px 0;\n  background: var(--bg);\n}\n\n.wu-section--white {\n  background: var(--bg);\n  padding-top: 56px;\n}\n\n.wu-section--white .wu-container {\n  max-width: 1320px;\n}\n\n.wu-philosophy {\n  display: grid;\n  grid-template-columns: 360px 1fr;\n  gap: 44px;\n  align-items: start;\n}\n\n.wu-philosophy__image {\n  position: relative;\n  overflow: hidden;\n}\n\n.wu-philosophy__image img {\n  width: 70%;\n  height: 200x;\n  object-fit: cover;\n  display: block;\n  border-radius: 0;\n  margin-left: 2rem;\n}\n\n.wu-imageTag {\n  display: none;\n}\n\n.wu-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap:12px;\n  color: #400C4D;\n  font-weight: 900;\n  font-size: 0.9rem;\n  letter-spacing: 0.14em;\n}\n\n.wu-eyebrow__line {\n  width: 26px;\n  height: 2px;\n  background: #400C4D;\n  border-radius: 999px;\n  opacity: 0.9;\n}\n\n.wu-title {\n  margin: 10px 0 10px;\n  font-family: Lexend, Inter, system-ui, sans-serif;\n  font-weight: 900;\n  letter-spacing: -0.02em;\n  font-size: var(--wu-type-subheading);\n  line-height: 1.12;\n  color:#400C4D\n}\n\n.wu-text {\n  margin: 0 0 12px;\n  color: #400C4D;\n  font-size: var(--wu-type-body);\n  line-height: 1.65;\n}\n\n.wu-quoteBox {\n  position: relative;\n  background: #d6c3d9;\n  border: 1px solid #400C4D;\n  border-radius: 12px;\n  padding: 14px 16px 16px 10px;\n  margin: 10px 0 12px;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);\n  font-size: 20px ;\n}\n\n.wu-quoteBox__bar {\n  position: absolute;\n  left: 14px;\n  top: 14px;\n  bottom: 14px;\n  width: 6px;\n  background: #400C4D;\n  border-radius: 999px;\n}\n\n.wu-quoteBox p {\n  margin: 0;\n  padding-left: 10px;\n  color: #2b3a55;\n  font-size: 1.125rem;\n  font-style: italic;\n  line-height: 1.55;\n}\n\n.wu-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  color: #400C4D;\n  font-weight: 900;\n  font-size: 18px;\n}\n\n.wu-link__arrow {\n  font-weight: 900;\n}\n\n.wu-centerTitle {\n  margin: 0;\n  text-align: center;\n  font-family: Lexend, Inter, system-ui, sans-serif;\n  font-weight: 900;\n  font-size: 25px;\n  letter-spacing: -0.02em;\n  line-height: 1.05;\n  color: #400C4D;\n}\n\n.wu-centerSub {\n  margin: 8px auto 0;\n  text-align: center;\n  color: #400C4D;\n  font-size: 16px;\n  max-width: 520px;\n  line-height: 1.55;\n}\n\n.wu-what-layout {\n  margin-top: 12px;\n  display: grid;\n  gap: 28px;\n  grid-template-columns: minmax(210px, 0.65fr) minmax(0, 2.35fr);\n  align-items: start;\n  margin-left: -420px;\n}\n\n.wu-what-image {\n  border-radius: 0;\n  overflow: visible;\n  position: relative;\n  z-index: 3;\n  margin-left: 0;\n  transform: translate(70px, -140px);\n\n}\n\n.wu-what-image img {\n  width: 160%;\n  max-width: none;\n  height: auto;\n  min-height: 100px;\n  display: block;\n  margin-left: 0;\n  margin-bottom: 0;\n  object-fit: contain;\n}\n\n.wu-what-content {\n  display: flex;\n  flex-direction: column;\n  margin-left: 0;\n}\n\n.wu-what-title {\n  margin: 0 0 10px;\n  text-align: center;\n  font-family: Lexend, Inter, system-ui, sans-serif;\n  font-weight: 900;\n  font-size: var(--wu-type-heading);\n  color: #400C4D;\n  line-height: 1.1;\n  margin-left: 0;\n}\n\n.wu-what-sub {\n  margin: 0 0 24px;\n  text-align: center;\n  color: #400C4D;\n  font-size: var(--wu-type-body);\n  line-height: 1.6;\n  margin-left: 0;\n  max-width: 760px;\n  align-self: center;\n}\n\n.wu-grid {\n  margin-top: 26px;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.wu-card {\n  background: #ece4ed;\n  border: 1px solid rgba(64, 12, 77, 0.14);\n  border-radius: 24px;\n  padding: 26px 22px;\n  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05);\n  min-height: 235px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  justify-content: flex-start;\n}\n\n.wu-card__icon {\n  width: 96px;\n  height: 96px;\n  border-radius: 999px;\n  background: #d6c3d9;\n  color: #400C4D;\n  display: grid;\n  place-items: center;\n  margin-bottom: 14px;\n}\n\n.wu-card__icon .material-symbols-outlined {\n  font-size: 38px;\n}\n\n.wu-card__title {\n  margin: 0 0 10px;\n  font-weight: 900;\n  font-size: clamp(1.4rem, 1.5vw, 1.75rem);\n  color:#400C4D\n}\n\n.wu-card__text {\n  margin: 0;\n  color: #400C4D;\n  font-size: clamp(1.05rem, 1.15vw, 1.3rem);\n  line-height: 1.5;\n}\n\n.wu-card:nth-child(3n + 2) {\n  background: #400C4D;\n  border-color: #400C4D;\n  box-shadow: 0 20px 34px rgba(64, 12, 77, 0.3);\n}\n\n.wu-card:nth-child(3n + 2) .wu-card__icon {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.wu-card:nth-child(3n + 2) .wu-card__title,\n.wu-card:nth-child(3n + 2) .wu-card__text {\n  color: #ffffff;\n}\n\n.wu-elite {\n  margin-top: 34px;\n  background: #ece4ed;\n  border-radius: 20px;\n  padding: 26px 18px 22px;\n}\n\n.wu-elite__title {\n  margin: 0 0 18px;\n  text-align: center;\n  color: #400C4D;\n  font-family: Lexend, Inter, system-ui, sans-serif;\n  font-weight: 800;\n  font-size: clamp(26px, 2.8vw, 42px);\n}\n\n.wu-elite__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.wu-eliteCard {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.03));\n  border: 2px solid #400C4D;\n  border-radius: 16px;\n  padding: 24px 20px;\n  text-align: center;\n  min-height: 230px;\n}\n\n.wu-eliteCard__icon {\n  width: 62px;\n  height: 62px;\n  margin: 0 auto 14px;\n  border-radius: 50%;\n  border: 2px solid #400C4D;\n  display: grid;\n  place-items: center;\n  color: #400C4D;\n}\n\n.wu-eliteCard__icon .material-symbols-outlined {\n  font-size: 31px;\n}\n\n.wu-eliteCard__title {\n  margin: 0 0 10px;\n  color: #400C4D;\n  font-size: var(--wu-type-card-heading);\n  font-weight: 800;\n}\n\n.wu-eliteCard__text {\n  margin: 0;\n  color: #400C4D;\n  font-size: 15px;\n  line-height: 1.55;\n}\n\n.wu-eliteCard__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  text-align: left;\n}\n\n.wu-eliteCard__item {\n  position: relative;\n  color: #400C4D;\n  font-size: var(--wu-type-card-body);\n  line-height: 1.6;\n  padding-left: 22px;\n  margin-bottom: 7px;\n}\n\n.wu-eliteCard__item:last-child {\n  margin-bottom: 0;\n  font-weight: 800;\n}\n\n.wu-eliteCard__item::before {\n  content: \"▶\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: #400C4D;\n  font-size: 0.9rem;\n  line-height: 1.8;\n}\n\n.wu-bottom {\n  background: #d6c3d9;\n  padding: 60px 0;\n}\n\n.wu-bottom__inner {\n  text-align: center;\n}\n\n.wu-bottom__title {\n  margin: 0;\n  font-family: Lexend, Inter, system-ui, sans-serif;\n  font-weight: 900;\n  font-size: clamp(26px, 3vw, 38px);\n  letter-spacing: -0.02em;\n  line-height: 1.05;\n  color:#400C4D\n}\n\n.wu-bottom__text {\n  margin: 12px auto 0;\n  max-width: 560px;\n  color: #400C4D;\n  font-size: var(--wu-type-body);\n  line-height: 1.6;\n}\n\n.wu-actions {\n  margin-top: 18px;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.wu-btn {\n  border: none;\n  cursor: pointer;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-weight: 900;\n  font-size: var(--wu-type-cta);\n  transition: transform 0.15s ease, filter 0.15s ease;\n}\n\n.wu-btn:hover {\n  transform: translateY(-1px);\n  color: #f59e0b;\n  filter: brightness(1.02);\n}\n\n.wu-btn--primary {\n  background: #400C4D;\n  color: #fff;\n  box-shadow: 0 10px 20px rgba(64, 12, 77, 0.25);\n}\n\n.wu-btn--secondary {\n  background: #fff;\n  color: #400C4D;\n  border: 1px solid #cfe0ff;\n}\n\n@media (max-width: 980px) {\n  .wu-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .wu-elite__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .wu-philosophy {\n    grid-template-columns: 1fr;\n  }\n  .wu-philosophy__image img {\n    height: 320px;\n  }\n  .wu-what-layout {\n    grid-template-columns: 1fr;\n  }\n  .wu-what-image img {\n    min-height: 360px;\n  }\n}\n\n@media (max-width: 640px) {\n  .wu-container {\n    padding: 0 16px;\n  }\n\n  .wu-section {\n    padding: 34px 0;\n  }\n\n  .wu-philosophy {\n    gap: 18px;\n  }\n\n  .wu-philosophy__image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2px;\n  }\n\n  .wu-philosophy__image img {\n    width: 48%;\n    height: auto;\n    margin-left: 0;\n  }\n\n  .wu-philosophy__content {\n    margin-top: 6px;\n  }\n\n  .wu-title {\n    font-size: 24px;\n    line-height: 1.18;\n  }\n\n  .wu-quoteBox {\n    padding: 14px 14px 16px 18px;\n  }\n\n  .wu-quoteBox__bar {\n    left: 10px;\n  }\n\n  .wu-quoteBox p {\n    padding-left: 14px;\n  }\n}\n\n@media (max-width: 520px) {\n  .wu-grid {\n    grid-template-columns: 1fr;\n  }\n  .wu-elite__grid {\n    grid-template-columns: 1fr;\n  }\n  .wu-hero {\n    margin: 0 0 0.75rem;\n    padding: 1.5rem 1rem 1.1rem;\n    border-radius: 0 0 16px 16px;\n  }\n\n  .wu-hero__content {\n    gap: 0.75rem;\n  }\n\n  .wu-hero__visual {\n    min-height: 150px;\n    background-position: center 35%;\n    transform: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .wu-what-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-left: 0;\n  }\n\n  .wu-what-image {\n    margin-left: 0;\n    transform: translate(0, 0);\n  }\n\n  .wu-what-image img {\n    min-height: 320px;\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n  .wu-what-content {\n    margin-left: 0;\n  }\n\n  .wu-what-title,\n  .wu-what-sub {\n    margin-left: 0;\n  }\n\n  .wu-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .wu-card {\n    width: 100%;\n    min-height: 180px;\n  }\n\n  .wu-grid::-webkit-scrollbar {\n    height: 6px;\n  }\n\n.wu-grid::-webkit-scrollbar-thumb {\n  background: rgba(64, 12, 77, 0.4);\n  border-radius: 999px;\n}\n\n}\n\n@media (max-width: 960px) {\n  .wu-hero__content {\n    flex-direction: column;\n    text-align: left;\n  }\n\n  .wu-hero__visual {\n    width: 100%;\n    min-height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
